import { useQuery } from '@tanstack/react-query';
import { fetchMeProjects, type MeTeamWithProjects } from '../../lib/api';
import { queryKeys } from './queryKeys';

const workspaceShellStaleTime = 10 * 60 * 1000;

export const useMeProjects = (
  token: string | null,
  options?: { enabled?: boolean; refetchOnWindowFocus?: boolean },
) => {
  return useQuery<MeTeamWithProjects[]>({
    queryKey: queryKeys.me.projects,
    queryFn: () => fetchMeProjects(token as string),
    enabled: Boolean(token) && (options?.enabled ?? true),
    refetchOnWindowFocus: options?.refetchOnWindowFocus,
    staleTime: workspaceShellStaleTime,
  });
};
